import * as React from 'react';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import {datetimeFullToGui} from "../../helpers/date";
import {EllipsisTableCell} from "components/reports/EllipsisTableCell";
import {ReportDataType} from "pages/ReportsPage";
import {useAppTranslation} from "../../services/i18n";

interface TestAnswersTableProps {
    data: ReportDataType['testAnswers'];
}

export const ReportTestAnswersTable: React.FC<TestAnswersTableProps> = ({data}) => {
    const t = useAppTranslation();

    return <TableContainer>
        <Table>
            <TableHead sx={{'& th': {backgroundColor: 'white'}}}>
                <TableRow sx={{backgroundColor: '#F5F5F5', '& .MuiTableCell-head': {color: '#8D8D8D', fontWeight: 'normal', borderTop: 'unset'}}}>
                    <TableCell>{t('reports.table.name')}</TableCell>
                    <TableCell>{t('reports.table.date')}</TableCell>
                    <TableCell>{t('reports.table.content')}</TableCell>
                    <TableCell>{t('reports.table.testName')}</TableCell>
                    <TableCell>{t('reports.table.question')}</TableCell>
                    <TableCell>{t('reports.table.answer')}</TableCell>
                    <TableCell>{t('reports.table.correctAnswer')}</TableCell>
                    <TableCell>{t('reports.table.maxPoints')}</TableCell>
                    <TableCell>{t('reports.table.isCorrect')}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {data?.map((row, index) => (
                    <TableRow
                        key={`${row.test_attempt_id}-${row.question_id}-${index}`}
                        sx={{
                            '&:nth-of-type(odd)': {backgroundColor: '#FAFAFA'},
                            '&:hover': {backgroundColor: '#efefef'}
                        }}
                    >
                        <TableCell>{row.user_name}</TableCell>
                        <TableCell>
                            {datetimeFullToGui(row.completion_date)}
                        </TableCell>
                        <EllipsisTableCell maxWidth="200px" title={row.content_name}>{row.content_name}</EllipsisTableCell>
                        <EllipsisTableCell maxWidth="150px" title={row.test_name}>{row.test_name}</EllipsisTableCell>
                        <EllipsisTableCell maxWidth="180px" title={row.question_title}>{row.question_title}</EllipsisTableCell>
                        <EllipsisTableCell maxWidth="160px" title={row.given_answer}>{row.given_answer}</EllipsisTableCell>
                        <EllipsisTableCell maxWidth="160px" title={row.correct_answer}>{row.correct_answer}</EllipsisTableCell>
                        <TableCell>{row.point_value}</TableCell>
                        <TableCell>
                            {row.is_correct ? t('common.yes') : t('common.no')}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>;
};
